import AdminAddProject from "../component/AdminPanelAdd";
import AdminPanelDelete from "../component/AdminPanelDelete";
import './AdminPanel.css'

function Admin(){
  return(
    <>
      <AdminAddProject />
      <AdminPanelDelete />
    </>
  )
}
export default Admin;